<script setup>
import { reactive } from 'vue'
import FileApi from '@api/file.api'
import getBlobDuration from 'get-blob-duration'

defineOptions({
    inheritAttrs: false,
})

const acceptedAudioTypes = ['audio/mpeg', 'audio/wav', 'audio/ogg'];
const acceptedVideoTypes = ['video/mp4', 'video/quicktime', 'video/x-msvideo', 'video/x-matroska'];

let myFiles = reactive({});

const props = defineProps({
    modelValue: [String, Number, Object],
    type: {
        type: String,
    },
    path: {
        type: String,
    },
    required: {
        type: Boolean,
    },
    multiple: {
        type: Boolean,
        default: false,
    },
    errors: {
        type: Object,
        default: {},
    },
})

const emit = defineEmits(["update:modelValue", 'uploaded'])

const handleFilePondInit = () => { }

const handleProcessfile = (error, file) => {
    if (!error && !props.multiple) {
        // console.log('from one', myFiles);
        emit('update:modelValue', myFiles)
        emit('uploaded', myFiles)
    }
}

const handleProcessfiles = () => {
    // console.log('from multiple', myFiles);
    emit('update:modelValue', myFiles)
    emit('uploaded', myFiles)
}

const process = (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
    // get file metadata
    let fileMetadata = {};
    fileMetadata = Object.assign(fileMetadata, metadata);
    fileMetadata = Object.assign(fileMetadata, {
        name: file.name,
        type: file.type,
        size: file.size,
        lastModified: file.lastModified,
        lastModifiedDate: file.lastModifiedDate,
    });

    // get video duration in seconds & add it to file metadata
    if (acceptedVideoTypes.includes(file.type) || acceptedAudioTypes.includes(file.type)) {
        getBlobDuration(file)
            .then((duration) => fileMetadata.duration = Math.round(duration));
    }

    // set file data to formData
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('type', props.type);

    if (props.path) {
        formData.append('folder', props.path);
    }

    // related to aborting the request
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const reqBody = {
        method: 'POST',
        url: FileApi.entity,
        data: formData,
        cancelToken: source.token,
        onUploadProgress: (e) => {
            // updating progress indicator
            progress(e.lengthComputable, e.loaded, e.total);
        }
    }

    FileApi.upload(reqBody)
        .then(response => {
            const fileID = response.data.data.file.id;

            // set file id to filemetadata
            fileMetadata = Object.assign(fileMetadata, { id: fileID })

            // passing the file id to FilePond
            load(fileID)

            myFiles[fileID] = fileMetadata;

            return fileID;
        }).catch((thrown) => {
            if (axios.isCancel(thrown)) {
                console.log('Request canceled', thrown.message);
            } else {
                // handle error
            }
        });

    // Setup abort interface
    return {
        abort: () => {
            source.cancel('Operation canceled by the user.');
            abort();
        }
    };
}

const server = reactive({
    process,
})
</script>

<template>
    <div class="input-group">
        <label class="form-label position-relative mb-3" :for="$attrs.id" v-if="$attrs.label">{{ $attrs.label }}</label>
    </div>
    <file-pond name="test" ref="pond" :label-idle="$attrs['label-idle'] || $t('messages.drop_files_here')"
        :allow-multiple="multiple" accepted-file-types="image/jpeg, image/png" :server="server" @init="handleFilePondInit"
        @processfile="handleProcessfile" @processfiles="handleProcessfiles" />
</template>